import classNames from "classnames";
import React, { ReactElement, CSSProperties, ReactNode, Ref } from "react";
import styles from "./Container.module.css";

interface Props {
  children: ReactNode | ReactNode[];
  style?: CSSProperties;
  wide?: boolean;
  border?: boolean
  className?: string;
  innerRef?: Ref<HTMLDivElement>
}

const Container = ({ children, style, wide, border, className, innerRef }: Props): ReactElement => {
  return (
    <div
      ref={innerRef}
      className={classNames(
        styles.container,
        wide && styles.wrapperWide,
        !wide && styles.wrapper,
        border && styles.border,
        className && className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

Container.defaultProps = {
  style: undefined,
  wide: false,
  border: false,
  className: ""
};

export default Container;
